export enum ButtonAppearance {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  SubPrimary = 'sub-primary',
}

export enum ButtonType {
  Button = 'button',
  Text = 'text',
  Link = 'link',
  DashLink = 'dash-link',
  Icon = 'icon',
  Multiline = 'multiline',
}

export enum ButtonSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
